(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("findAF", [], factory);
	else if(typeof exports === 'object')
		exports["findAF"] = factory();
	else
		root["findAF"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 